function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import m, { useMemo as d, useRef as M } from "react";
import { Features as H, Hidden as T } from '../internal/hidden.js';
import { useEvent as E } from './use-event.js';
import { useOwnerDocument as b } from './use-owner.js';
function N() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultContainer = _ref.defaultContainers,
    o = _ref$defaultContainer === void 0 ? [] : _ref$defaultContainer,
    r = _ref.portals,
    u = _ref.mainTreeNodeRef;
  var f;
  var t = M((f = u == null ? void 0 : u.current) != null ? f : null),
    l = b(t),
    c = E(function () {
      var i, s, a;
      var n = [];
      var _iterator = _createForOfIteratorHelper(o),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          _e !== null && (_e instanceof HTMLElement ? n.push(_e) : "current" in _e && _e.current instanceof HTMLElement && n.push(_e.current));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (r != null && r.current) {
        var _iterator2 = _createForOfIteratorHelper(r.current),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var e = _step2.value;
            n.push(e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var _iterator3 = _createForOfIteratorHelper((i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : []),
        _step3;
      try {
        var _loop = function _loop() {
          var e = _step3.value;
          e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some(function (L) {
            return e.contains(L);
          }) || n.push(e));
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return n;
    });
  return {
    resolveContainers: c,
    contains: E(function (n) {
      return c().some(function (i) {
        return i.contains(n);
      });
    }),
    mainTreeNodeRef: t,
    MainTreeNode: d(function () {
      return function () {
        return u != null ? null : m.createElement(T, {
          features: H.Hidden,
          ref: t
        });
      };
    }, [t, u])
  };
}
function y() {
  var o = M(null);
  return {
    mainTreeNodeRef: o,
    MainTreeNode: d(function () {
      return function () {
        return m.createElement(T, {
          features: H.Hidden,
          ref: o
        });
      };
    }, [o])
  };
}
export { y as useMainTreeNode, N as useRootContainers };